import { render, staticRenderFns } from "./Clock.vue?vue&type=template&id=06faa2e6&scoped=true&"
import script from "./Clock.vue?vue&type=script&lang=js&"
export * from "./Clock.vue?vue&type=script&lang=js&"
import style0 from "./Clock.vue?vue&type=style&index=0&id=06faa2e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06faa2e6",
  null
  
)

export default component.exports